import { Button } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { NoteModals } from '../../../../lib/NoteModals';
import { fetchInvestorDetails } from '../../../../redux-store/actions/nct';
import { RootStateType } from '../../../../redux-store/reducers';
import { LIST_PROTFOLIO_PAYLOAD, SCHEMES_RESPONSE } from '../../../../redux-store/types/portfolio';
import {
    getInvestorFunds,
    minorBelowEighteenYears,
    portfoliosByModeOfHolding,
    portfoliosByTransactionResource,
} from '../../portfolios/utils';
import { ConsolidateTableRowType } from '../ConsolidationFolios/types';
import NoFoliosFound from '../NoFoliosFound';
import en from '../../../../lang/en-us';
import { TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import moment from 'moment';
import { maskMobileNumber } from '../../../../utils/utilityFunctions';
import { BANK } from '../../../../redux-store/types/nct';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import {
    DEBT,
    EQUITY,
    getDateString,
    LIQUID,
    MINOR_MAJOR,
    OTHER,
} from '../../../../utils/constants';
import { ActionHeader, FaqLink } from '..';

const { dashboard } = en;

export const Columns: TableColumn[] = [
    {
        field: 'id',
        headerName: 'FOLIO',
    },
    {
        field: 'amcName',
        headerName: 'Fund House',
        width: 250,
        filterBy: true,
        filterHeader: 'Fund House',
        filterKey: 'amcName',
    },
    {
        field: 'guardian',
        headerName: 'Guardian Name',
        valueGetter: ({ row }) => row.guardian?.name || 'Not Available',
        width: 100,
    },
    {
        field: 'investorName',
        headerName: '1st Holder',
        width: 200,
    },
    {
        field: 'dob',
        headerName: 'D.O.B (Minor)',
        valueGetter: ({ row }) => getDateString(row?.dob),
        width: 100,
    },
    {
        field: 'dob',
        headerName: 'AGE (First Holder)',
        valueGetter: ({ row }) => new Date().getFullYear() - new Date(row?.dob).getFullYear(),
        width: 100,
    },
    {
        field: 'accountNo',
        headerName: 'ACCOUNT NO.',
        valueGetter: ({ row }) => {
            const defaultBank = row.bank.find((_ele: BANK) => _ele.default === 'Y') || {};
            return maskMobileNumber(defaultBank.accountNo);
        },
        width: 100,
    },
    {
        isFilter: true,
        field: 'assetType',
        headerName: 'Category',
        filterBy: true,
        renderStaticFilters: [EQUITY, LIQUID, DEBT, OTHER],
    },
];

function MinorStatus(props: any) {
    const [rowData, setRowData] = useState<ConsolidateTableRowType[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    // const [targetFunds, setTargetFunds] = useState<ConsolidateTableRowType[]>([]);
    const {
        selectedRows: targetFunds,
        setSelectedRows,
        tableColumns,
        tableRows,
        ...filters
    } = useTableWithCollapse<ConsolidateTableRowType[]>({
        rows: rowData,
        columns: Columns,
        loading,
    });
    useEffect(() => {
        setLoading(true);
        async function callApi() {
            const payload: LIST_PROTFOLIO_PAYLOAD = {
                pan: props.pan,
                mobile: props.mobile,
                pekrn: props.pekrn,
                reqId: props.reqId,
            };
            try {
                const { body: investorDetails = {} } = await props.fetchInvestorDetails(payload);
                const { success: investorFunds = [] } = investorDetails;
                const investorFundsRowData = getInvestorFunds(
                    investorFunds,
                    [
                        portfoliosByTransactionResource,
                        (fund: SCHEMES_RESPONSE) => !minorBelowEighteenYears(fund),
                    ],
                    [portfoliosByModeOfHolding],
                );
                setRowData(investorFundsRowData);
                setLoading(false);
            } catch (err: any) {
                alert(err.message);
            }
        }
        callApi();
        return () => { };
    }, []);

    const _isRowSeletable = ({ row }: { row: ConsolidateTableRowType }) => {
        if (targetFunds.length) {
            const [fund] = targetFunds;
            const addedPrimaryHolderName = fund.investorName;
            const defaultBankAccountNo: any = (
                fund.bank.find((_ele: BANK) => _ele.default === 'Y') || {}
            ).accountNo;
            const rowPrimaryHolderName = row.investorName;
            const rowDefaultAccountNo = (row.bank.find((_ele: BANK) => _ele.default === 'Y') || {})
                .accountNo;
            if (
                addedPrimaryHolderName === rowPrimaryHolderName &&
                defaultBankAccountNo === rowDefaultAccountNo
            ) {
                return true;
            }
            return false;
        }
        return true;
    };

    const _toolTipGetText = ({ row }: { row: ConsolidateTableRowType }) => {
        if (targetFunds.length) {
            const [fund] = targetFunds;
            const addedPrimaryHolderName = fund.investorName;
            const defaultBankAccountNo: any = (
                fund.bank.find((_ele: BANK) => _ele.default === 'Y') || {}
            ).accountNo;
            const rowPrimaryHolderName = row.investorName;
            const rowDefaultAccountNo = (row.bank.find((_ele: BANK) => _ele.default === 'Y') || {})
                .accountNo;
            if (addedPrimaryHolderName !== rowPrimaryHolderName) {
                return dashboard.MinorStatus.toolTipText.info1;
            }
            if (defaultBankAccountNo !== rowDefaultAccountNo) {
                return dashboard.MinorStatus.toolTipText.info2;
            }
        }
        return '';
    };

    const handleSubmit = () => {
        props.history.push('minor-status-pan', { targetFunds });
    };
    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.MinorStatus.MinorStatusHeading} />
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <h5> {dashboard.MinorStatus.MinorStatusInfo}</h5>
                    <div className="curved-table-content">
                        {' '}
                        {loading || !!tableRows.length ? (
                            <TableWithCollapse
                                rows={tableRows}
                                columns={tableColumns}
                                isRowSelectable={_isRowSeletable}
                                toolTipTextGetter={_toolTipGetText}
                                setSelectedRows={setSelectedRows}
                                selectedRows={targetFunds}
                                disableAllSelection
                                toolTipEnabled
                                checkBoxEnabled
                                {...filters}
                            />
                        ) : (
                            <NoFoliosFound info={dashboard.MinorStatus.EmptyNomineeInfo} />
                        )}
                    </div>
                    <FaqLink section={MINOR_MAJOR} history={props.history} />
                </div>
                <div className="curved-bg-content-inner-bottom">
                    {/* <p className="folio-errors">{dashboard.MinorStatus.differentPanError}</p> */}
                    {!!rowData.length && (
                        <div className="table-submit">
                            <Button
                                className="customBtn"
                                onClick={handleSubmit}
                                disabled={!targetFunds.length}
                            >
                                {dashboard.MinorStatus.buttonText}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
            {/* <NoteModals
                showModal={true}
                heading={dashboard.MinorStatus.noteModals.heading}
                info={dashboard.MinorStatus.noteModals.info}
                proceedBtn={dashboard.MinorStatus.noteModals.proceedText}
                cancelBtn={dashboard.MinorStatus.noteModals.cancelText}
            /> */}
        </div>
    );
}
export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    fetchInvestorDetails,
})(MinorStatus);
